export default {
    namespaced: true,

    state: () => {
        return {
            previous: {},

            data: {
                experienceType: null,
                flowType: null,
                groupId: null,
                properties: {},
                cascadeProperties: {},
                dynamicProviderKey: null,
                webSessionId: null,
                warnCountdownMillis: null,
                timeoutAfterMillis: null,
                extensions: [],
            },
        }
    },

    mutations: {
        update(state, session) {
            state.data = session
        },

        updatePrevious(state, session) {
            state.previous = session || {}
        },

        updateDynamicProviderKey(state, dynamicProviderKey) {
            state.data = { ...state.data, dynamicProviderKey }
        },
    },
}
